export default {
    url: '/spent_usd',
    template: require('./view.html'),
    data: {
        title: 'Season Spent USD',
        role: 'rating_arena',
        priority: 803,
    },
    reloadOnSearch: false,
};
